import { request } from './request'

// Only explicitly reviewed, anonymous, read-only endpoints belong here.
// Member, inventory, cart, order and payment endpoints must always bypass it.
const PUBLIC_TTL = Object.freeze({
  'system-images': 15000,
  'system-rights': 15000,
  seometas: 30000,
  'index-carousels': 15000,
  'index-marquees': 5000
})

const inFlight = new Map()
const cache = new Map()

const normalize = value => {
  if (Array.isArray(value)) return value.map(normalize)
  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce((result, key) => {
      result[key] = normalize(value[key])
      return result
    }, {})
  }
  return value
}

const cacheKey = (url, config) => `${url}|${JSON.stringify(normalize(config.params || {}))}`

export function publicGet (url, config = {}) {
  const ttl = PUBLIC_TTL[url]
  if (!ttl) return request.get(url, config)

  const key = cacheKey(url, config)
  const stored = cache.get(key)
  if (stored && stored.expiresAt > Date.now()) return Promise.resolve(stored.response)
  if (stored) cache.delete(key)
  if (inFlight.has(key)) return inFlight.get(key)

  const pending = request.get(url, config).then(response => {
    cache.set(key, { response, expiresAt: Date.now() + ttl })
    return response
  }).finally(() => {
    inFlight.delete(key)
  })

  inFlight.set(key, pending)
  return pending
}

export function clearPublicGetCache () {
  cache.clear()
}
